import { RestClient } from '@/api/rest-client'
import { TriggeredAction } from '@/api/model/triggered-action'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { User } from '@/api/model/user'
import { Source } from '@/api/model/source'
import { Branch } from '@/api/model/branch'
import { PipelinePhase } from '@/api/model/pipeline-phase'

export class TriggeredActionClient extends RestClient<TriggeredAction> {
    collectionName = 'triggered_actions'
    parseData = TriggeredAction.fromData

    async create(triggeredAction: TriggeredAction): Promise<TriggeredAction> {
        const request = cloneDeep<any>(triggeredAction)

        if (triggeredAction.actionAssignTo) {
            request.actionAssignTo = triggeredAction.actionAssignTo
                .filter((user: User) => user instanceof User)
                .map((user: User) => user.resourceIdentifier)
        }

        if (triggeredAction.company instanceof Company) {
            request.company = triggeredAction.company.resourceIdentifier
        }

        if (triggeredAction.referralPipeline instanceof Pipeline) {
            request.referralPipeline = triggeredAction.referralPipeline.resourceIdentifier
        }

        if (triggeredAction.actionComment === null) {
            request.actionComment = ''
        }

        if (triggeredAction.newReferralPipeline instanceof Pipeline) {
            request.newReferralPipeline = triggeredAction.newReferralPipeline.resourceIdentifier
        }

        if (triggeredAction.phase instanceof PipelinePhase) {
            request.phase = triggeredAction.phase.resourceIdentifier
        }

        if (triggeredAction.assignedToBranch instanceof Branch) {
            request.assignedToBranch = triggeredAction.assignedToBranch.resourceIdentifier
        }

        if (triggeredAction.assignedTo instanceof User) {
            request.assignedTo = triggeredAction.assignedTo.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: any): Promise<TriggeredAction> {
        const request = cloneDeep<any>(data)

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        if (data.actionComment === null) {
            request.actionComment = ''
        }

        if (data.actionAssignTo) {
            request.actionAssignTo = data.actionAssignTo
                .filter((user: User) => user instanceof User)
                .map((user: User) => user.resourceIdentifier)
        }

        if (data.newReferralPipeline instanceof Pipeline) {
            request.newReferralPipeline = data.newReferralPipeline.resourceIdentifier
        }

        if (data.phase instanceof PipelinePhase) {
            request.phase = data.phase.resourceIdentifier
        }

        if (data.assignedToBranch instanceof Branch) {
            request.assignedToBranch = data.assignedToBranch.resourceIdentifier
        }

        if (data.assignedTo instanceof User) {
            request.assignedTo = data.assignedTo.resourceIdentifier
        }

        return super.update(id, request)
    }
}
